export default "__VITE_ASSET__D9lzRpLb__"